import React from "react";
import className from "~/kernel/styling/className";
import Icon from "./Icon";

type Props = {
  children: React.ReactNode;
  type?: "info" | "error" | "success" | "warning";
  subtle?: boolean;
};

export default function Alert({ children, type = "info", subtle }: Props) {
  if (subtle) {
    return (
      <div
        className="flex flex-row items-start gap-2 border border-slate-200 rounded-md p-3 bg-white"
        role="alert"
      >
        {
          {
            info: (
              <Icon className="!leading-relaxed text-info" name="circle-info" />
            ),
            error: (
              <Icon
                className="!leading-relaxed text-error"
                name="circle-xmark"
              />
            ),
            success: (
              <Icon
                className="!leading-relaxed text-positive"
                name="circle-check"
              />
            ),
            warning: (
              <Icon
                className="!leading-relaxed text-warning"
                name="triangle-exclamation"
              />
            ),
          }[type]
        }
        <div>{children}</div>
      </div>
    );
  }

  return (
    <div
      className={className(
        "rounded-md border border-l-4 bg-white p-5 shadow-lg",
        () => {
          switch (type) {
            case "info":
              return "border-l-info";
            case "warning":
              return "border-l-warning";
            case "error":
              return "border-l-error";
            case "success":
              return "border-l-positive";
          }
        },
      )}
      role="alert"
    >
      {children}
    </div>
  );
}

Alert.defaultProps = {
  type: "info",
};
